import { APICore } from './apiCore';
const api = new APICore();

// jobSubmissions
function jobSubmissions(params: {
    search: string,
    sortBy: string,
    limit: number,
    page: number,
}) {
    const baseUrl = `/job-submissions`;
    return api.get(`${baseUrl}`, params);

}

export {
    jobSubmissions
};
